/**
 * L'interface mobile reste disponible volontairement sous /m, mais le
 * cockpit ne doit jamais y être redirigé automatiquement. Les liens vers
 * /dashboard affichent ainsi le même tableau de bord responsive sur iPhone,
 * tablette et ordinateur.
 */
export default function MobileGuard() {
  return null;
}
